import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'collectionToString',
  pure: true
})
export class CollectionToStringPipe implements PipeTransform {

  transform(value: Array<any>, property: string = 'title' ): string{
    return (value.length > 0) ? value.slice().map((v) => v[property]).join(', ') : '';
  }

}
